import styled from 'styled-components';
import { CodeBox, TextCopy } from '@trevor/ui-components';
import React from 'react';
import { useEmbedDashboard } from '@/hooks/useEmbedDashboard';
import { useSelector } from 'react-redux';
import { getDashboardState } from '@/features/dashboardShare/store-selectors';
import { userAction } from '@/util/helpers/ajax-helpers';

const disabledMessage =
  'Click the Configure Your Dashboard Embed button and follow the instructions to activate this.';

const EmbedDashboardConfigurationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
`;

export const EmbedDashboardConfigurations = () => {
  const { isPublic } = useSelector(getDashboardState);
  const { embedUrl, embedCode, isConfigured } = useEmbedDashboard();
  const isDisabled = !isConfigured && !isPublic;

  return (
    <EmbedDashboardConfigurationsContainer>
      <CodeBox
        onCopy={() =>
          userAction('embed-dashboards-sidebar-embed-dashboard', {
            action: 'iframe-embed-copy',
          })
        }
        language="javascript"
        disabled={isDisabled}
        disabledTooltip={disabledMessage}
      >
        {embedCode}
      </CodeBox>
      <TextCopy
        onCopy={() =>
          userAction('embed-dashboards-sidebar-embed-dashboard', {
            action: 'embed-url-copy',
          })
        }
        onOpen={() =>
          userAction('embed-dashboards-sidebar-embed-dashboard', {
            action: 'embed-url-open',
          })
        }
        text={embedUrl}
        isUrl
        disabled={isDisabled}
        disabledTooltip={disabledMessage}
      />
    </EmbedDashboardConfigurationsContainer>
  );
};
